import React from "react"
import { Div, Text } from "atomize"
import PrimaryButton from "../buttons/PrimaryButton"
import Container from "../atoms/Container"
import { theme } from "../settings/config"

const getInfos = subject => {
	let infoTitle = null
	let infoBody = null
	let infoAction = null

	switch (subject) {
		case "lastUpdate":
			infoTitle = "Aggiornamento lezioni"
			infoBody = (
				<>
					<Text>
						Le lezioni vengono salvate su questo dispositivo per velocizzare la
						visualizzazione.
					</Text>
					<Text>
						Se qualcuno modifica le lezioni per te o lo fai tu stesso, ma da un altro
						dispositivo, potresti non avere tutto aggiornato.
					</Text>
					<Text m={{ t: "0.5rem" }}>
						Vuoi aggiornarle? Tocca il bottone a lato con le frecce!
					</Text>
				</>
			)
			infoAction = "Capito!"
			break
		default:
			break
	}
	return { infoTitle, infoBody, infoAction }
}

export function ExplanationModal({ closeModal, subject }) {
	const infos = getInfos(subject)

	return (
		<>
			<Container>
				<Div bg={theme.colors.background} rounded="20px" m={{ t: "0", b: "1rem" }}>
					<Div m={{ b: "0.5rem" }} textWeight="bold" textSize="title">
						{infos.infoTitle}
					</Div>
					{infos.infoBody}
				</Div>
				<Div m={{ x: "1rem" }}>
					<Div m="auto">
						<PrimaryButton
							m="auto"
							bg="gunmetal_fill"
							textColor="white"
							text={infos.infoAction}
							textSize="subheader"
							action={closeModal}
						/>
					</Div>
				</Div>
			</Container>
		</>
	)
}

export default ExplanationModal
